import { render, staticRenderFns } from "./FCPWrapper.vue?vue&type=template&id=51c0872c"
import script from "./FCPWrapper.vue?vue&type=script&lang=js"
export * from "./FCPWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports